import { motion } from "framer-motion";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_URL } from "./config";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      data-testid="floating-whatsapp-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatear por WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, delay: 2 }}
      className="pulse-ring fixed bottom-5 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-wagreen text-white shadow-[0_15px_35px_-10px_rgba(37,211,102,0.7)] transition duration-300 hover:scale-110 sm:h-16 sm:w-16"
    >
      <WhatsAppIcon className="h-7 w-7 sm:h-8 sm:w-8" />
      <span className="absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-choco px-4 py-2 text-xs font-bold text-cream shadow-lg md:block">
        Atención inmediata
      </span>
    </motion.a>
  );
}
